import { getPromotions } from 'lib/graphql/campaigns/campaigns.client';
import { mapCriteriaToQuery } from '../mapCriteriaToQuery';

export const getPromotionsState = async ({ apolloClient, promo, displayQualifier = true, currency }) => {
	if (!promo) {
		return {
			valid: false,
			error: false,
		};
	}
	const { data, errors } = await getPromotions(apolloClient, {
		code: promo,
		displayQualifier,
		currency,
	});

	const hadError = !!errors;
	if (hadError) {
		return {
			code: promo,
			valid: false,
			error: true,
			errorMessage: errors,
		};
	}
	const { promotions } = data || {};
	const [promotion = {}] = promotions || [];
	const { criteria = [], code, title, status, perks, lockup, extended, endDate, id, countdownEnabled, enabled } = promotion;

	if (!enabled) {
		return {
			code: promo,
			valid: false,
			error: true,
		};
	}

	const mapCriteria = criteria.map((val) => {
		return {
			ship: val.ships || [],
			destination: val.destination || [],
			departurePort: val.departurePort || [],
			nights: val.nights || [],
			startDate: val.startDate || [],
			cabinClass: val.cabinClass || [],
		};
	});

	const criteriaToSearchSelection = mapCriteria.reduce(
		(acc, cur) => {
			const { ship, startDate, destination, departurePort, nights, cabinClass } = cur;
			const queryDate = startDate.map((date) => {
				const startDate = date.start.split('T')[0];
				const endDate = date.end.split('T')[0];
				return `${startDate}~${endDate}`;
			});
			acc.ship.push(...ship);
			acc.startDate.push(...queryDate);
			acc.destination.push(...destination);
			acc.departurePort.push(...departurePort);
			acc.nights.push(...nights);
			acc.cabinClass.push(...cabinClass);
			return acc;
		},
		{
			ship: [],
			startDate: [],
			destination: [],
			departurePort: [],
			nights: [],
			cabinClass: [],
		},
	);

	const queryCriteria = mapCriteriaToQuery({ criteria: mapCriteria });

	return {
		valid: true,
		error: false,
		criteria: mapCriteria,
		code,
		title,
		status,
		queryCriteria,
		criteriaToSearchSelection,
		perks,
		lockup,
		extended,
		endDate,
		id,
		countdownEnabled,
	};
};
